import React from "react";
import { connect } from "react-redux";

import type { ReduxState } from "@/modules/pg/shared/planningTable/reducers/reducers";

type OwnProps = {};
type Props = OwnProps & ReduxProps;

class PlanningTableSaveSpinner extends React.Component<Props> {
    render() {
        if (this.props.loading) {
            return <i className="fas fa-spinner fa-spin"></i>;
        }
        return null;
    }
}

const mapState = (state: ReduxState) => {
    const parallel_report = state.gantt_chart_parallel_report;
    return {
        loading: parallel_report.parallel_report_loading,
    };
};

type ReduxProps = ReturnType<typeof mapState>;

export default connect<ReduxProps, {}, OwnProps, ReduxState>(mapState, {})(PlanningTableSaveSpinner);
